import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { ProductGrade } from '@app/core/interfaces';
import { ReviewProductNameIdData } from '@app/core/models/review-product-name-id-data';
import { ProductIdNameService } from '@app/core/services/product-id-name.service';
import { CapitalizePipe } from '@app/shared/pipes/capitalize/capitalize.pipe';
import { ProductGradeKeyValue } from '@app/store/product-grade/product-grade-key-value.interface';
import { ProductGradeService } from '@app/store/product-grade/product-grade.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductGradeOptions } from './product-grade-options';

@Component({
    selector: 'cyno-product-grade-container',
    exportAs: 'productGradeContainer',
    template: `
        <ng-container>
            <ng-content></ng-content>
        </ng-container>
    `,
})
export class ProductGradeContainer implements OnInit, OnChanges {
    @Input() title: string;
    @Input() subtitle: string;
    @Input() reviewId: ReviewIdEnum;
    @Input() description?: string;
    @Input() firstCharacter?: number;
    @Input() secondCharacter?: number;
    @Input() number: boolean = true;

    public options: ProductGradeOptions;

    public isBrowser: boolean = isPlatformBrowser(this.platformId);

    public productGrade$: Observable<ProductGrade>;

    constructor(private productGradeService: ProductGradeService, @Inject(PLATFORM_ID) public platformId: Object) {}

    ngOnInit(): void {
        this.onProductIdChange();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.product_name) {
            this.onProductIdChange();
        }
    }

    private onProductIdChange(): void {
        if (this.reviewId) {
            if (this.isBrowser) {
                this.productGrade$ = this.productGradeService
                    .getProductGradeByReviewId$(this.reviewId)
                    .pipe(map((productGradeKeyValue: ProductGradeKeyValue) => productGradeKeyValue?.value));
                this.productGradeService.loadGradeByReviewId(this.reviewId);
            }

            const data = ProductIdNameService.getDataByReviewId(this.reviewId);

            this.options = {
                title: this.getTitle(data),
                productName: data.productName,
                subtitle: this.subtitle,
                description: this.description || '',
                firstCharacter: this.firstCharacter,
                secondCharacter: this.secondCharacter,
                number: this.number,
                reviewUrl: data.appRoute,
            };
        }
    }

    private getTitle(data: ReviewProductNameIdData): string | null {
        if (this.title) {
            return this.title;
        }

        if (data.productName === 'InShared') {
            return `Beoordeling ${data.productName}`;
        }

        const capitalizePipe = new CapitalizePipe();
        return `Beoordeling ${capitalizePipe.transform(data.productName)}`;
    }
}
